import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token); // exp is in seconds
    if (!exp) return true;
    const now = Date.now() / 1000; // current time in seconds
    return exp < now;
  } catch (err) {
    return true; // if decoding fails, treat as expired
  }
}

export function isTokenExpiredOrExpiringSoon(token, bufferSeconds = 300) {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;
    return exp < (Date.now() / 1000) + bufferSeconds;
  } catch {
    return true;
  }
}
